import styled from "styled-components/macro";
import { TOOLBAR_GROUP_GAP, TOOLBAR_ITEM_WIDTH } from "./toolbarLayout";

export const StyledContainer = styled.div`
  text-align: left;
  border-bottom: 2px solid var(--divider);
  padding: 10px 0;
  height: 26px;
  user-select: none;
  display: flex;
  justify-content: space-between;

  &.sticky-toolbar {
    position: sticky;
    top: 0;
    background: var(--menu-color);
    border-radius: 24px 24px 0 0;
    z-index: 4;

    /* The sticky GeneratePanel pins directly below the toolbar with an inline
       z-index of 10 (draftGeneratePanelSticky.js), which would cover the
       overflow dropdown. Only outrank it while the dropdown is open. */
    &.overflow-open {
      z-index: 11;
    }
  }

  .hidden-items-menu {
    width: 100%;
    height: 100%;
  }

  &.collapsed {
    border-bottom: 2px solid transparent;
    &.sticky-toolbar {
      background-color: transparent;
      z-index: 11;
      pointer-events: none;
    }
    li {
      .collapse {
        pointer-events: auto;

        .icon-wrapper {
          background-color: var(--document-background);
          border-radius: 5px;
          box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 15px;
        }

        &:hover,
        &:focus-visible {
          .icon-wrapper {
            background-color: var(--document-background-hover);
          }
        }

        &:active {
          .icon-wrapper {
            background-color: var(--document-background-active);
          }
        }

        svg {
          transform: rotate(180deg);
        }
      }
    }

    li,
    .hidden-items,
    .hidden-items-menu {
      display: none;
    }

    ul.left-container li:last-child {
      display: inline-block;
    }
  }

  .chapter-select {
    width: 150px;
  }

  .toolbar-icon {
    color: var(--grey-2);
    svg {
      circle {
        fill: var(--grey-2);
      }
    }

    .hover-tip {
      width: 80px;
    }
  }

  ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;

    &.right-container {
      margin-left: 8px;
      flex: 1 1 0;
      min-width: 0;

      li:first-of-type {
        .hover-tip {
          left: 100%;
          .arrow {
            left: 33%;
          }
        }
      }
    }

    &.left-container {
      justify-content: flex-end;
      margin-right: 8px;
      margin-left: 16px;
      flex: 0 0 auto;

      li:last-of-type {
        .hover-tip {
          left: 0%;
          .arrow {
            left: 67%;
          }
        }
      }
    }

    &.hidden-items {
      position: absolute;
      top: 105%;
      padding: 6px 10px;
      background: var(--menu-color);
      border-radius: 10px;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15), 0px 0px 1px 0px rgba(0, 0, 0, 0.25);
      right: 8px;
      max-width: calc(100% - 16px);
      box-sizing: border-box;
      flex-wrap: wrap;
    }

    &.right-container > li,
    &.hidden-items > li {
      flex: 0 0 ${TOOLBAR_ITEM_WIDTH}px;
      width: ${TOOLBAR_ITEM_WIDTH}px;
      box-sizing: border-box;

      &.group-start {
        position: relative;
        flex-basis: ${TOOLBAR_ITEM_WIDTH + TOOLBAR_GROUP_GAP}px;
        width: ${TOOLBAR_ITEM_WIDTH + TOOLBAR_GROUP_GAP}px;
        padding-left: ${TOOLBAR_GROUP_GAP}px;

        &::before {
          content: "";
          position: absolute;
          left: 8px;
          top: 50%;
          transform: translateY(-50%);
          height: 18px;
          width: 1px;
          background: var(--divider);
          pointer-events: none;
        }
      }
    }

    li {
      display: inline-block;

      .toolbar-icon {
        width: ${TOOLBAR_ITEM_WIDTH}px;
        svg {
          path {
            fill: var(--grey-2);
          }
        }

        &.active {
          color: var(--grey-0);
          svg {
            path {
              fill: var(--grey-0);
            }
          }
        }

        // These two glyphs mix strokes and filled circles. Keep every part in
        // the button's active/inactive color without filling the open checkmarks.
        &.list-icon {
          svg circle {
            fill: currentColor;
          }
          svg line,
          svg path {
            stroke: currentColor;
          }
          svg path {
            fill: none;
          }
        }

        &.bold {
          font-weight: 600;
        }

        &.underline {
          text-decoration: underline;
        }

        &.strike {
          text-decoration: line-through;
        }

        &.prose-generator {
          &.active {
            color: var(--primary-cta-high-contrast);
            svg {
              path {
                fill: var(--primary-cta-high-contrast) !important;
              }
            }
          }
        }

        &.comment-mode {
          &.active {
            color: var(--primary-cta-high-contrast);
            svg {
              path {
                fill: var(--primary-cta-high-contrast) !important;
              }
            }
          }
        }

        &.spellcheck,
        &.grammarcheck {
          &.active {
            color: var(--primary-cta-high-contrast);
            svg {
              path {
                fill: var(--primary-cta-high-contrast) !important;
              }
            }
          }
        }

        &.history {
          color: var(--grey-2);
          // svg {
          //   width: 20px;
          //   height: 20px;
          //   fill: var(--grey-2);
          // }
        }
      }
    }
  }
`;
